import "../../scss/Cases.scss";
import polina from "../../images/polina.png";
import prime2u from "../../images/prime2u.png";
import giftup from "../../images/giftup.png";
import primeDiamonds from "../../images/prime-diamonds.png";
import mobile1 from "../../images/mobile1.png";
import mobile2 from "../../images/mobile2.png";
import mobile3 from "../../images/mobile3.png";
import mobile4 from "../../images/mobile4.png";
import mobile5 from "../../images/mobile5.png";
import mobile6 from "../../images/mobile6.png";

export default function Cases() {
  return (
    <section className="cases" id="cases">
      <div className="cases__container">
        <h2 className="cases__title">НЕКОТОРЫЕ КЕЙСЫ</h2>

        {/* Проект 1 */}
        <div className="cases__item">
          <img src={polina} alt="Polina Atelier" className="cases__image" />
          <div className="cases__content">
            <h3 className="cases__project-title">Polina Atelier</h3>
            <p className="cases__desc">
              Педантичный подход для клиентов, которые видят красоту в деталях —
              мебельное ателье, точно сформировавшее свои потребности. Сложные
              адаптивы, плавные анимации, расстановка объектов в точности до
              пикселей. Требовательные клиенты и креативные задачи — то, с чем
              мы справляемся как никто.
            </p>
            <br />
            <p className="cases__quote">
              Отзыв клиента: <br />
              <span>
                «Кажется, мы были самыми требовательными клиентами. 😅 Спасибо
                ребятам за терпение, внимательность и аккуратность, всё
                выполнено идеально, до мельчайших деталей. А еще понимание
                дизайнеров с полуслова, это конечно было волшебно :) »
              </span>
            </p>
          </div>
        </div>

        <div className="cases__divider"></div>

        {/* Проект 2 */}
        <div className="cases__item">
          <img src={prime2u} alt="Prime 2U" className="cases__image" />
          <div className="cases__content">
            <h3 className="cases__project-title">Prime 2U</h3>
            <p className="cases__desc">
              Бренд одежды Prime 2U представляет собой женственность, нежность и
              качество. Но за всей интерфейсной легкостью и непринужденностью
              стоит сложнейшая архитектурная работа. Интеграции с CRM, МойСклад,
              Apple Wallet, платежной системой ТБанк и оплатой Долями, кастомная
              административная панель — все это было реализовано в этом, с виду
              легком, проекте.
            </p>
            <br />
            <p className="cases__desc">
              Отдельная гордость — это мобильная версия, реализованная в стиле
              полноценного моб. приложения. Функциональный tab-bar с анимациями,
              приближенным к нативным, интеграция с iOS в аспектах систем
              лояльности, совершения звонков и отправки писем. Канонический
              проект, которым по праву можно гордиться.
            </p>
          </div>
        </div>

        <div className="cases__divider"></div>

        {/* Проект 3 */}
        <div className="cases__item">
          <img src={giftup} alt="GiftUp" className="cases__image" />
          <div className="cases__content">
            <h3 className="cases__project-title">GiftUp</h3>
            <p className="cases__desc">
              Крипто-разработка — то, с чего начиналась наша студия. Нашим
              первым проектом была сложная система крипто-облигаций для
              известного фармацевтического бренда. С тех пор мы выпустили
              множество крипто-проектов, не все из которых можем вам
              продемонстрировать; мы лишь хотим, чтобы вы знали — блокчейн это
              наша стихия, а GiftUp — тому подтверждение. Моментальное включение
              в задачу, стремительное проектирование и качественная реализация.
            </p>
            <p className="cases__quote">
              Отзыв клиента: <br />
              <span>
                «We worked with right shift on GiftUp, a blockchain-based
                gifting platform. The team quickly understood the Web3 logic,
                proposed a clear user flow and a clean visual concept. The
                deadlines were extremely tight, but they delivered on time —
                calm, precise, and fully in control throughout the process.»
              </span>
            </p>
          </div>
        </div>

        <div className="cases__divider"></div>

        {/* Проект 4 */}
        <div className="cases__item">
          <img
            src={primeDiamonds}
            alt="Prime Diamonds"
            className="cases__image"
          />
          <div className="cases__content">
            <h3 className="cases__project-title">Prime Diamonds</h3>
            <p className="cases__desc">
              Легкость, прозрачность и чистота — именно эти качества
              ассоциируются с бриллиантами высокого качества. В этом бюджетном,
              конструкторном проекте мы отразили все перечисленные
              характеристики в интерфейсе. Для Prime Diamonds мы делали не
              только сайт, но и медиа-контент с маркетинговыми услугами.
              Благодаря таргетированной рекламе, нам удалось в разы увеличить
              продажи бренда по входящим потокам.
            </p>

            <p className="cases__quote">
              Отзыв клиента: <br />
              <span>
                «Нам нужен был сайт в краткие сроки и с небольшим бюджетом.
                Получилось то, что нужно: лаконичный дизайн, понятная структура,
                удобная работа с каталогом для менеджера (что важно для взрослых
                людей). Работать с ними приятно — понимают с полуслова,
                доходчиво объясняют технические тонкости на простом языке. »
              </span>
            </p>
          </div>
        </div>

        <div className="cases__divider"></div>

        {/* Последний блок */}
        <div className="cases__final">
          <div className="cases__text">
            <h3 className="cases__project-title">
              Несколько слов о мобильных интерфейсах
            </h3>
            <p className="cases__desc">
              «Мы понимаем, насколько важна мобильная версия — сегодня именно с
              телефона начинается большинство взаимодействий с брендом. Для нас
              адаптив — не техническая опция, а неотъемлемая часть стратегии
              восприятия. Мы проектируем интерфейсы, которые остаются удобными,
              точными и выразительными на любом экране. В наших мобильных
              решениях всё продумано: от микроанимаций, до хронологии взгляда и
              клика»
            </p>
          </div>

          <div className="cases__images cases__slider">
            {[mobile1, mobile2, mobile3, mobile4, mobile5, mobile6].map(
              (img, i) => (
                <div className="cases__slide" key={i}>
                  <img src={img} alt={"Mobile UI " + (i + 1)} />
                </div>
              )
            )}
          </div>
        </div>
      </div>
    </section>
  );
}
